module.exports = __webpack_public_path__ + "img/activity10.d981aa3f.jpg";